import {RouteRecordRaw} from "vue-router";
import Index from "../pages/multimedia/Multimedia.vue";

export const Multimedia: RouteRecordRaw[] = [
    {name: 'multimedia', path: '/multimedia', meta: {title: 'Multimedia'}, component: Index},
];